var paytreeInit = () => {
  const popup = document.getElementById('checkout-popup');
  const form = document.getElementById('checkout-popup-form');
console.log(111, popup, form)
  if (!popup || !form) return;

  // OPEN / CLOSE POPUP
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-checkout-popup-open]')) {
      popup.classList.remove('hidden');
    }

    if (
      e.target.id === 'checkout-popup-cancel' ||
      e.target.classList.contains('checkout-popup__overlay')
    ) {
      popup.classList.add('hidden');
    }

    document.querySelector('.cart-drawer__close-button').click();
  });

  // SUBMIT FORM
  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // GET CART FROM SHOPIFY
    const cart = await fetch('/cart.js').then(r => r.json());

    // GET CUSTOMER + ADDRESS DATA FROM FORM
    const data = Object.fromEntries(new FormData(form).entries());
const cartId = cart;
console.log('cartId1', cart);
    try {
      // SEND EVERYTHING TO BACKEND
      const res = await fetch('https://payment.31.97.36.48.sslip.io/api/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop: Shopify.shop,

          // CART DATA
          cart_token: cart.token,
          items: cart.items.map(i => ({
            title: i.product_title,
            variant_id: i.variant_id,
            quantity: i.quantity,
            price: i.price / 100
          })),
          total: cart.total_price / 100,
          currency: cart.currency,

          // CUSTOMER DATA
          customer: {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            phone: data.phone
          },

          // ADDRESS DATA
          address: {
            street: data.street,
            city: data.city,
            state: data.state,
            zip: data.zip,
            country: data.country
          }
        })
      }).then(r => r.json());

      // HANDLE RESPONSE
      if (!res.payment_link) {
        alert('Payment initialization failed');
        return;
      }

      // REDIRECT TO PAYMENT PAGE (Stripe via Paytree)
      window.location.href = res.payment_link;

    } catch (err) {
      console.error(err);
      alert('Something went wrong');
    }
  });

};

paytreeInit();
